export default __webpack_public_path__ + "177997439016a172cfd94acea1d2ab6e.png";